import { useEffect } from "react";

import { useAuth } from "@/contexts/auth-context";

import { NoticeScreen } from "./signup-parts";

// F06 신청 완료 안내 (Figma ver.6 546:1803)
export function NavigatorSignupCompletePage() {
  return (
    <NoticeScreen
      tone="success"
      title="가입 신청이 완료되었습니다"
      description="관리자 승인 후 이용할 수 있으며 승인 결과는 메일로 안내됩니다. 승인 전 로그인 시 승인 대기 안내가 표시됩니다."
    />
  );
}

// 사전 초대 가입 완료 (Figma ver.6 546:6327 · 설계서 slide 96): 승인 없이 바로 이용 — 가입과 함께 로그인된 상태라 사용자 정보를 다시 읽어요.
export function NavigatorInviteCompletePage() {
  const { refreshUser } = useAuth();
  useEffect(() => {
    void refreshUser().catch(() => {});
  }, [refreshUser]);
  return <NoticeScreen tone="success" title="가입이 완료되었습니다" description="관리자 승인 없이 바로 AI Agent Navigator를 이용할 수 있어요." />;
}
